import React, { FunctionComponent, useMemo } from "react";
import { Image, useColorModeValue } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import StatsTable from "components/stats-table";
import RtuStatus from "./RtuStatus"
import ControlMode from "./ControlMode"


interface IProps {
  data: any;
  uiVersion: string;
}


const RtuCommandStatsTable: FunctionComponent<IProps> = ({ data, uiVersion }) => {
  const intl = useIntl();
  const darkIconUrl = useMemo(() => {
    switch (uiVersion) {
      case "opuncie": return "/images/svg/command-icon-cez-dark.svg";
    }
  }, [uiVersion]);
  const lightIconUrl = useMemo(() => {
    switch (uiVersion) {
      case "opuncie": return "/images/svg/command-icon-cez-light.svg";
    }
  }, [uiVersion]);

  return (
    <StatsTable
      mb={8}
      rows={[
        {
          label: intl.formatMessage({
            id: "command__rtu_command__distributor",
            defaultMessage: "Distributor",
          }),
          value: <Image src={useColorModeValue(lightIconUrl, darkIconUrl)} h={8} />,
        },
        {
          label: intl.formatMessage({
            id: "command__rtu_command__rtu_state",
            defaultMessage: "RTU state",
          }),
          value: <RtuStatus state={data.state} />,
        },
        {
          label: intl.formatMessage({
            id: "command__rtu_command__limit_out",
            defaultMessage: "Production limit",
          }),
          unit: "kW",
          value: data.limit_out,
        },
        {
          label: intl.formatMessage({
            id: "command__rtu_command__limit_in",
            defaultMessage: "Charging limit",
          }),
          unit: "kW",
          value: data.limit_in,
        },
        {
          label: intl.formatMessage({
            id: "command__rtu_command__control_mode",
            defaultMessage: "Control mode",
          }),
          value: <ControlMode state={data.control_mode} />,
        },
        {
          label: intl.formatMessage({
            id: "command__control_mode__setpoint__reactive_power",
            defaultMessage: "Reactive power setpoint",
          }),
          decimals: 0,
          unit: "kVAR",
          value: data.reactive_power,
        },
        {
          label: intl.formatMessage({
            id: "command__control_mode__setpoint__power_factor",
            defaultMessage: "Power factor setpoint",
          }),
          decimals: 2,
          value: data.power_factor,
        },
        {
          label: intl.formatMessage({
            id: "command__control_mode__setpoint__voltage",
            defaultMessage: "Voltage setpoint",
          }),
          decimals: 0,
          unit: "V",
          value: data.voltage,
        }
      ]}
    />
  );
};

export default RtuCommandStatsTable;
